<section class="ThecheesesPage">
      <div fxLayout="row" fxLayoutAlign="center start">
         <div fxFlex="98%" fxFlex.gt-md="92%">
             <div fxLayout="row" fxLayoutAlign="center start">
               <div class="pageTitle">
                  <h4>Our Cheese</h4>
               </div>
             </div>
         </div>
      </div>
      <div fxLayout="row">
         <div fxFlex="100%">
            <img fxFlex="100%" src="https://static.wixstatic.com/media/cf6097_3a52fbf514314732ad462897ea5c700c~mv2.jpg/v1/fill/w_1024,h_408,al_c,q_85,enc_auto/cf6097_3a52fbf514314732ad462897ea5c700c~mv2.jpg" alt="">
         </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="center start" class="my-30">
         <div fxFlex="98%" fxFlex.gt-md="92%" class="catPro">
             
            <div fxLayout="row wrap" fxLayoutGap.gt-md="30px">
               <div fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)" fxLayoutAlign="end start">
                  <img src="https://static.wixstatic.com/media/cf6097_d9c732309fb94c328b024c073541c3e1~mv2.jpg/v1/fill/w_268,h_317,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/cf6097_d9c732309fb94c328b024c073541c3e1~mv2.jpg" alt="">
               </div>
               <div fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)">
                  <div fxFlex="50%">
                     <h5>Grisontaler</h5>
                     <p>Named after the combination of the farm name and Switzerland's famous Emmentaler, the name translates to, “of the Grison Valley.” Grisontaler is a raw milk Swiss style cheese aged for a minimum of 60 days. The cheese has a pleasant nuttyness with strong flavors which grow stronger when one eats the cheese.  This cheese is one of Adrian's first attempts at creating his own recipe.</p>
                  </div>
               </div>
             </div>
             <div fxLayout="row wrap" fxLayoutGap.gt-md="30px">
               <div fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)" fxLayoutAlign="end start">
                  <div fxFlex="50%">
                     <h5>Ozark Mutschli</h5>
                     <p>Grison Dairy & Creamery’s second creation is pasturized and has a pleasant creamy flavor and texture. It is very mild. It is named after the Ozark Mountains and Mutschli, a traditional cheese produced throughout Switzerland. Many different types of Mutschli are produced, but they all tend to be a small washed rind cheese. The brine used to wash the cheese helps give it a distinct aroma.</p>
                  </div>
               </div>
               <div fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)" >
                  <img src="https://static.wixstatic.com/media/cf6097_da19fbfc58ef43eeacee5d71a0f8afaa~mv2.jpg/v1/fill/w_260,h_318,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/cf6097_da19fbfc58ef43eeacee5d71a0f8afaa~mv2.jpg" alt="">
               </div>
             </div>


             <div fxLayout="row wrap" fxLayoutGap.gt-md="30px">
               <div fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)" fxLayoutAlign="end start">
                  <img src="https://static.wixstatic.com/media/cf6097_d32e9cc35ad740deb824b0acac091627~mv2.jpg/v1/fill/w_390,h_477,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/cf6097_d32e9cc35ad740deb824b0acac091627~mv2.jpg" alt="">
               </div>
               <div fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)">
                  <div fxFlex="50%">
                     <h5>Säntis</h5>
                     <p>Grison Dairy & Creamer's Säntis is modeled after the Appenzeller cheese. It is named after the iconic mountain in Eastern Switzerland where the Appenzeller is traditionally produced. This raw milk cheese is made with spring milk and is aged for a minimum of 60 days. During the aging it is washed in a special herb and local beer solution which helps give it flavor. This Creamy cheese is only availabe for an exclusive amount of time each year.</p>
                  </div>
               </div>
             </div>
             <div fxLayout="row wrap" fxLayoutGap.gt-md="30px">
               <div fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)" fxLayoutAlign="end start">
                  <div fxFlex="50%">
                     <h5>Raclette of the Ozarks</h5>
                     <p><span style="font-size:16px;" class="wixui-rich-text__text">Raclette is a traditonal cheese from the southern Swiss canton of Vallis (Wallis) It is traditionally served melted over potatoes. Our very own Raclette melts amazingly. It is only avaliable through&nbsp;<span style="text-decoration:underline;" class="wixui-rich-text__text"><a href="https://raclettecorner.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Raclette Corner.</a></span>&nbsp;They can ship all over the US. Critics have called it a delightful surprise and milder yet so rich and nutty.</span></p>
                  </div>
               </div>
               <div fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)" >
                  <img src="https://static.wixstatic.com/media/cf6097_a56bd6950c764904ad0e37bcab4c494f~mv2.jpg/v1/fill/w_390,h_477,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/cf6097_a56bd6950c764904ad0e37bcab4c494f~mv2.jpg" alt="">
               </div>
             </div>

             <div fxLayout="row wrap" fxLayoutGap.gt-md="30px">
               <div fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)" fxLayoutAlign="end start">
                  <img src="https://static.wixstatic.com/media/cf6097_a709166d70504cb99583ad657e230aac~mv2.png/v1/fill/w_390,h_477,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Enzian%20Bleu.png" alt="">
               </div>
               <div fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)">
                  <div fxFlex="50%">
                     <h5>Enzian Bleu
                     </h5>
                     <p>Named after the beautiful Enzian Flower which grows on the mountains of Switzerland. Our Cheesemaker, Adrian remembers the summers in his youth when he visited his Grandmother in Davos. They would walk up the mountain and see this beautiful flower. The Enzian Bleu is a raw milk bleu cheese great for burgers, dips, salads, polenta, salad dressing, toast and on your favorite steaks.​​​

                     </p>
                  </div>
               </div>
             </div>

             <div fxLayout="row wrap" fxLayoutGap.gt-md="50px" class="my-30">
               <div fxFlex="100%" fxFlex.gt-md="calc(50% - 50px)">
                  <img fxFlex="100%" src="https://static.wixstatic.com/media/cf6097_2f098b5e1f1b46a881b01256a87f91e7~mv2.jpg/v1/fill/w_832,h_550,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/cf6097_2f098b5e1f1b46a881b01256a87f91e7~mv2.jpg" alt="">
               </div>
               <div fxFlex="100%" fxFlex.gt-md="calc(50% - 50px)">
                  <img fxFlex="100%" src="https://static.wixstatic.com/media/cf6097_9a8077ea5f2f472596a4c9ab34afff4e~mv2.jpg/v1/fill/w_768,h_508,al_c,q_85,enc_auto/cf6097_9a8077ea5f2f472596a4c9ab34afff4e~mv2.jpg" alt="">
               </div>
             </div>
         </div>
      </div>
   </section>